// Note: Be sure the @vp/react-tracking version in package.json supports the version here.
export const TRACKING_LIB_VERSION = '9';
